import { forwardRef, ForwardRefExoticComponent, useMemo } from 'react';
import {
  NavLinkProps,
  NavLink as ReactRouterNavLink,
  useSearchParams,
} from 'react-router-dom';

interface CustomLinkProps {
  persistQueryParams?: boolean;
}

export const NavLink: ForwardRefExoticComponent<
  NavLinkProps & CustomLinkProps & React.RefAttributes<HTMLAnchorElement>
> = forwardRef(({ persistQueryParams = true, to: toProp, ...props }, ref) => {
  const [searchParams] = useSearchParams();

  const to = useMemo(() => {
    if (!persistQueryParams) return toProp;
    const newSearchParams = new URLSearchParams(searchParams);

    if (typeof toProp === 'string' && toProp.includes('?')) {
      const searchString = toProp.split('?')[1];
      const searchParams = new URLSearchParams(searchString);
      searchParams.forEach((value, key) => {
        newSearchParams.set(key, value);
      });
    } else if (typeof toProp.search === 'string') {
      const searchParams = new URLSearchParams(toProp.search);
      searchParams.forEach((value, key) => {
        newSearchParams.set(key, value);
      });
    }

    const toWithoutSearch =
      typeof toProp === 'string' ? toProp.split('?')[0] : toProp.pathname;
    return `${toWithoutSearch}?${newSearchParams.toString()}`;
  }, [toProp, persistQueryParams, searchParams]);

  return <ReactRouterNavLink ref={ref} {...props} to={to} />;
});
